import script from "./DonateSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonateSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./DonateSuccess.vue?vue&type=style&index=0&id=8ec5ddbe&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ec5ddbe"]])

export default __exports__